import React, {useState, useEffect} from 'react';
import ipfs from 'decentralized/Ipfs.js';
import ethereum from 'decentralized/ethereum.js';
import ConditionedComponent from 'components/ConditionedComponent.js';

export default ({work, onClick, mixMode, sequencerEngine}) => {
    const [author, setAuthor] = useState('');
    const [authors, setAuthors] = useState({});
    const [works, setWorks] = useState([]);
    const [mix, setMix] = useState({});

    useEffect(() => {
        ethereum.users.getUserName(work.user)
            .then(name => setAuthor(name));
    }, [work, setAuthor]);

    useEffect(() => {
        if (work) {
            // fetch works
            if (work.works) {
                setMix(work);
                setWorks(work.works);
            } else {
                ipfs.getJson(work.mixHash)
                    .then(mix => {
                        mix.mixHash = work.mixHash;
                        setWorks(mix.works);
                        setMix(mix);
                    });
            }
        }
    }, [work, setWorks, setMix]);

    useEffect(() => {
        (async () => {
            let obj = {};
            for (let i in works) {
                obj[works[i].user] = await ethereum.users.getUserName(works[i].user);
            }
            setAuthors(obj);
        })();
    }, [works, setAuthors]);

    const unloadMix = () => {
        sequencerEngine.unloadAll();
    };

    let deleteButton = '';
    if (mixMode) {
        deleteButton = (
            <div
              onClick={unloadMix}
              className="delete-button">
              x
            </div>
        );
    }

    let isEdit = work.previousHash && work.previousHash !== '';
    return (
        <div
          onClick={() => onClick(mix)}
          className="work work-mix">
          {deleteButton}
          <div className="mix-info">
            {works.map(
                work =>
                    [work.title + ' - ', <span className="work-author">{authors[work.user]}</span>]
            )}
          </div>
          <div className="name">
            <div className="work-author">
              {author}
            </div>
            <div className="title">
              {work.title}
            </div>
            <div className="mix-edit-info">
              {isEdit ? 'Edit' : 'Original'}
            </div>
            <div className="mix-background">
              MIX
            </div>
          </div>
        </div>);
};
